import * as $ from "jquery";

async function init() {
  // Get filters from available companies
  $(".js-filter").each(function() {
    const filters = $(this)
      .next()
      .find("> div")
      .map(function() {
        return $(this).data("categories");
      })
      .get()
      .join(",");

    let categories = filters.split(",");
    const uniqueCategories = new Set(categories);
    categories = Array.from(uniqueCategories).sort();
    categories.push(categories.splice(categories.indexOf("Other"), 1)[0]);

    const list = $(this).find("> ul");
    $.each(categories, i => {
      $("<li/>")
        .addClass("directory-panel__filter-list-item")
        .attr("data-filter", categories[i])
        .text(categories[i])
        .appendTo(list);
    });
  });

  // Filter by multiple categories
  $(".js-filter").on("click", "> ul li", function() {
    const filter = $(this).data("filter");
    $(this)
      .addClass("active")
      .siblings()
      .removeClass("active");
    if (filter === "*") {
      $(this)
        .closest(".js-filter")
        .next()
        .find("> div")
        .show();
    } else {
      $(this)
        .closest(".js-filter")
        .next()
        .find("> div")
        .hide();
      $(this)
        .closest(".js-filter")
        .next()
        .find("> div[data-categories*='" + filter + "']")
        .show();
    }

    if (window.innerWidth < 480) {
      $(".js-dropdown")
        .next()
        .slideUp(300);
      $(".js-dropdown")
        .removeClass("active")
        .find(".icon:last-child")
        .removeClass("active");
    }
  });

  // Scrollable filter list (if there are too many)
  $(".directory-panel__filter-list").each(function() {
    const listWidth = $(this).outerWidth(true);
    let listItemsWidth = 0;

    $(this)
      .find("> li")
      .each(function() {
        listItemsWidth += $(this).outerWidth(true);
      });

    if (listItemsWidth > listWidth) {
      $(this).addClass("is-scrollable");
      $(this)
        .parent()
        .prepend(
          $(
            '<div class="directory-panel__filter-scroll-prev js-filter-scroll-prev">&lt;</div>'
          )
        )
        .append(
          $(
            '<div class="directory-panel__filter-scroll-next js-filter-scroll-next active">&gt;</div>'
          )
        );
    }

    $(this)
      .siblings(".js-filter-scroll-next")
      .on("click", function() {
        $(this)
          .siblings(".directory-panel__filter-list")
          .animate({ scrollLeft: listItemsWidth - listWidth + 22 }, 600);
        $(this)
          .removeClass("active")
          .siblings(".js-filter-scroll-prev")
          .addClass("active");
      });

    $(this)
      .siblings(".js-filter-scroll-prev")
      .on("click", function() {
        $(this)
          .siblings(".directory-panel__filter-list")
          .animate({ scrollLeft: 0 }, 600);
        $(this)
          .removeClass("active")
          .siblings(".js-filter-scroll-next")
          .addClass("active");
      });
  });
}

export default { init };
